import { BaseSupabaseService } from './BaseSupabaseService';
import { Address } from '../types';
import { handleServiceError } from '../utils/errorHandler';
import { requestEdgeFunction } from './edgeFunctionClient';

class AddressServiceClass extends BaseSupabaseService<Address> {
  constructor() {
    super('addresses');
  }

  async findByStudentId(studentId: number): Promise<Address | null> {
    const results = await this.findAll({
      filters: [{ column: 'student_id', value: studentId }],
    });
    return results[0] || null;
  }

  async findByStudentIds(studentIds: number[]): Promise<Address[]> {
    if (studentIds.length === 0) return [];
    try {
      const response = await requestEdgeFunction<{ data: Address[] }>('students', {
        method: 'POST',
        body: {
          action: 'list-student-addresses',
          payload: { studentIds },
        },
      });
      return response.data ?? [];
    } catch (error) {
      handleServiceError(error, 'buscar endereços');
      return [];
    }
  }

  async upsertForStudent(studentId: number, data: Partial<Address>): Promise<Address> {
    const existing = await this.findByStudentId(studentId);
    if (existing) {
      return this.update(existing.id, data);
    }
    return this.create({ ...data, student_id: studentId });
  }
}

export const AddressService = new AddressServiceClass();
